<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Agz3lT/images/e9781439612378_cover.jpg?1684245184984" alt="This image is the cover for the book African-American Entertainment in Baltimore, Black America Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">African-American Entertainment in Baltimore, Black America Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Take a trip down the Pennsylvania Avenue of years past, the heart of Baltimore's African-American community, when the streets vibrated with life and bass.</b></p><br/><p>From 1930 to 1980, Baltimore was a key city to the success of Black entertainers, such as The Ink Spots, Cab Calloway, Sammy Davis Jr., Billie Holiday, Ella Fitzgerald, and countless others, while The Avenue's hottest night spots such as the legendary Royal Theater, the Regent Theater, the Sphinx, and Club Casino bumped and jived until the early hours of morning. Along with the DJS and promoters who helped cultivate the city's musical talents, and the people who were just there to have a groovy time, <i>African-American Entertainment in Baltimore</i> captures the brilliance of the city's musical heritage.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rosa Pryor-Trusty, Tonya Taliaferro
      </h2>
      
      <p class="authorDescription body article">Authors Rosa Pryor-Trusty and Tonya Taliaferro underscore their commitment to preserving the city's past while paying homage to some of Black America's premier performers with this treasured photo history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0dbfa6f7